export default __webpack_public_path__ + "static/farid-shabanov-849c0b28add403f22dbca492d04798d2.png";